import Phaser from 'phaser';
import { BRASS, hudText } from './text';

// Touch devices: − / + buttons (pinch would fight the twin sticks).
// Keyboard users have + / - and the wheel in the game scene.
export function buildZoomButtons(
  scene: Phaser.Scene,
  consumePointer: () => void,
  onZoom: (delta: number) => void,
): Phaser.GameObjects.Container {
  const c = scene.add.container(0, 0).setDepth(50);
  const mk = (dx: number, label: string, delta: number) => {
    const bg = scene.add.circle(dx, 0, 20, 0x070a08, 0.6).setStrokeStyle(1, BRASS, 0.8);
    const t = hudText(scene, dx, 0, label, 20, '#e8d7a8').setOrigin(0.5);
    bg.setInteractive({ useHandCursor: true }).on(Phaser.Input.Events.POINTER_DOWN, () => {
      consumePointer();
      onZoom(delta);
    });
    c.add([bg, t]);
  };
  mk(-26, '−', -1);
  mk(26, '+', 1);
  return c;
}
